export class NSValidation {
    
    isEmpty(value:any): boolean {
        if(typeof value == "undefined" || typeof value == "string" || typeof value == "number" || typeof value == "boolean") {
            if(typeof value == "undefined" || value == "") {
                return true;
            }
            if(typeof value == "string" && value.trim()=="") {
                return true;
            }
        }
        return false;
    }

    isEmail(value:any): boolean {
        if(!this.isEmpty(value) && typeof value == "string") {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(value).toLowerCase());
        }
        else {
            return false;
        }
    }

    isNumberOnly(value:any): boolean {
        if(!this.isEmpty(value)) {
            var re = /^\d+$/;
            return re.test(String(value).toLowerCase());
        }
        else {
            return false;
        }
    }

    isStrongValue(value:any): boolean
    {
        var re = /(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{6,}/;
        return re.test(value);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/classes/NSValidation.ts